import { render, staticRenderFns } from "./projectWasteStat.vue?vue&type=template&id=7c550c76&scoped=true&"
import script from "./projectWasteStat.vue?vue&type=script&lang=js&"
export * from "./projectWasteStat.vue?vue&type=script&lang=js&"
import style0 from "./projectWasteStat.vue?vue&type=style&index=0&id=7c550c76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c550c76",
  null
  
)

component.options.__file = "projectWasteStat.vue"
export default component.exports